import gql from "graphql-tag";
import PostFields from "../../fragments/engagement/PostFields";

export default gql`
  mutation CreatePost(
    $contextKey: String
    $contextType: PostContextType!
    $bodyAsJson: JSON!
    $bodyAsPlainText: String!
    $title: String
  ) {
    createPost(
      contextKey: $contextKey
      contextType: $contextType
      bodyAsJson: $bodyAsJson
      bodyAsPlainText: $bodyAsPlainText
      title: $title
    ) {
      ...PostFields
    }
  }

  ${PostFields}
`;
